export const PADDING = 8;
export const Y_PADDING = PADDING * 2; // top and bottom padding
export const X_PADDING = PADDING * 2; // left and right padding
export const VERTICAL_SPACING = 16;
